import * as React from 'react';

export function useQuestionario() {
  const [questionsForm, setQuestionsForm] = React.useState([]);

  const handleChangeQuestionsForm = React.useCallback((data) => {
    setQuestionsForm(data);
  }, []);

  return {
    questionsForm,
    handleChangeQuestionsForm,
  };
}
